import ajax from '../../../../scanline/utils/ajax';
import { hasAccessToken } from '../../../../scanline/utils/token';

const isDefined = v => v !== undefined && v !== null;

export const listSurveysNoReadings = ({ offset, limit } = {}, callback) => {
	const url =
		isDefined(offset) && isDefined(limit)
			? `/noReadingsQuery/${encodeURIComponent(
					'Customer'
			  )}/offset/${offset}/limit/${limit}`
			: `/noReadingsQuery/${encodeURIComponent('Customer')}`;

	if (hasAccessToken()) {
		ajax(url, 'dataIntegrity', 'GET', (err, res) => {
			if (err) {
				callback(err);
			} else {
				callback(null, res);
			}
		});
	}
};

const _exports = {
	listSurveysNoReadings
};

export default {
	..._exports
};
